module.exports = __webpack_public_path__ + "static/media/Avatars-4.2.580845d0.svg";